/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationConstraint from './radiation-constraint';
import RadiationConstraintDetail from './radiation-constraint-detail';
import RadiationConstraintUpdate from './radiation-constraint-update';
import RadiationConstraintDeleteDialog from './radiation-constraint-delete-dialog';

const RadiationConstraintRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationConstraint />} />
    <Route path="new" element={<RadiationConstraintUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationConstraintDetail />} />
      <Route path="edit" element={<RadiationConstraintUpdate />} />
      <Route path="delete" element={<RadiationConstraintDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationConstraintRoutes;
